import { environment } from "./environment";
import { mapping } from "./environment-mapping.const";


export function getEnvironment() {
  return mapping[HostGetter.getHost()];
}

export const HostGetter = {
  getHost() {
    if (location.host.includes('localhost:')) {
      return 'localhost';
    }

    return location.host;
  },
};

export const loadEnvironmentFactory = () => {
  return () => {
    return new Promise<void>((resolve) => {
      const runtimeEnvironment = getEnvironment();
      if (!runtimeEnvironment) {
        throw new Error('Environment not found');
      }
      Object.assign(environment, runtimeEnvironment);
      resolve();
    });
  };
};
